import {Box3, Group, Matrix4, Mesh, Object3D, Vector3} from "three";
import {Constructor} from "../../util/constructor-wrapper";
import {nodeTraverse} from "../../util/node-traverse";


/**
 * Provides attribute resolution for implementations of the Comparable Mixin class
 */
export type ComparableMapping<T extends Object3D<any>> = {
    _object: T
}

/**
 * interface of the Comparable feature
 */
export interface Comparable {

    get matrixWorld(): Matrix4
    get matrix(): Matrix4
    get size(): Vector3
    get center(): Vector3
    computeBoundingBox(): void
}

/**
 * Mixin for the Comparable feature
 * @param base
 */
export function Comparable< Tbase extends Constructor<ComparableMapping<any>>> (base: Tbase): Constructor<Comparable> {

    return class Comparable extends base implements Comparable {
        matrix: Matrix4 = this._object.matrix
        matrixWorld: Matrix4 = this._object.matrixWorld

        get size(): Vector3 {
            if(this._object instanceof Group) return new Box3().setFromObject(this._object).getSize(new Vector3());
            if(this._object instanceof Mesh) return this._object.geometry.boundingBox?.getSize(new Vector3())
            return new Vector3();
        }

        get center(): Vector3 {
            if(this._object instanceof Group) return new Box3().setFromObject(this._object).getCenter(new Vector3());
            if(this._object instanceof Mesh) return this._object.geometry.boundingBox?.getCenter(new Vector3())
            return new Vector3();
        }

        computeBoundingBox() {
            this._object.traverse((node: Object3D) => { if(node instanceof Mesh) { node.geometry.computeBoundingBox() } })
        }

    };

}